const $ = jQuery.noConflict();

const AfterSubmitSuccessContactForm = {
	$domCF7: $('.wpcf7'),

	/**
	 * @description Initialize
	 */
	init: function() {
		this.contactFormSubmit();
	},

	/**
	 * @description On submit success disable button
	 */
	contactFormSubmit: function() {
		$('form.wpcf7-form').on('submit', function() {
			const form = $(this);
			const button = form.find('input[type=submit]');
			const current_val = button.val();
			// store the current value so we can reset it later
			button.attr('data-value', current_val);
			// disable the button
			button.prop('disabled', true);

		});
		AfterSubmitSuccessContactForm.$domCF7.on('wpcf7invalid', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
		AfterSubmitSuccessContactForm.$domCF7.on('wpcf7mailsent', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
	},
};

export default AfterSubmitSuccessContactForm;
